export default class GetCompanyDataRequestData {
  public countryISOCode: string | null;
  public taxNumber: string | null;

  public constructor (countryISOCode: string | null, taxNumber: string | null) {
    this.countryISOCode = countryISOCode
    this.taxNumber = taxNumber
  }
}
